export enum Permission {
  SearchPlatformView = 'search_platform.view',
  SearchPlatformModify = 'search_platform.modify',
}
